import type { ReactNode } from 'react';
import { CdHeading, CdText } from '../../atoms/CdTypography';
import styles from './CdContentPageTemplate.module.scss';

export interface CdContentPageTemplateProps {
  title: string;
  description?: string;
  breadcrumbs?: ReactNode;
  children?: ReactNode;
}

/** Simple page: breadcrumbs, title, intro and free content (help, placeholders, 404). */
export const CdContentPageTemplate = ({
  title,
  description,
  breadcrumbs,
  children,
}: CdContentPageTemplateProps) => {
  return (
    <div className={styles.page}>
      {breadcrumbs}
      <CdHeading level={1} size="xl">
        {title}
      </CdHeading>
      {description && (
        <CdText variant="bodyLarge" tone="secondary">
          {description}
        </CdText>
      )}
      {children && <div className={styles.body}>{children}</div>}
    </div>
  );
};
